import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppNgAppkitModule } from '../../../app-ng-appkit.module';
import { DatePickerWithClearComponent } from './date-picker-with-clear.component';

@NgModule({
  declarations: [DatePickerWithClearComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppNgAppkitModule,
  ],
  exports: [DatePickerWithClearComponent],
})
export class DatePickerWithClearModule {}
